import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Accordion, Button, Form, Modal, Tab, Tabs } from "react-bootstrap";
import ProjectLogs from "../components/ProjectLogs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MultiSelect } from "react-multi-select-component";
import { useDispatch, useSelector } from "react-redux";
import {
  addProjects,
  getAllEmployees,
  getProjects,
} from "../redux/actionCreator";
import { all_employees, project_data } from "../redux/commonReducer";
import axios from "axios";

const Projects = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const projectData = useSelector(project_data);
  const allEmployees = useSelector(all_employees);

  const [logs, setLogs] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [err, setErr] = useState({});
  const [data, setData] = useState({
    project_name: "",
    web_url: "",
    api_url: "",
    admin_url: "",
    members: [],
  });
  const [searchData, setSearchData] = useState({
    start_date: "",
    end_date: "",
    user: "",
    page: 0,
    keyword: "",
  });

  useEffect(() => {
    dispatch(getAllEmployees());
    getSearchDataHandler(searchData);
  }, []);

  const teams = [
    {
      img: "https://img.freepik.com/free-psd/3d-illustration-human-avatar-profile_23-2150671142.jpg?t=st=1743678297~exp=1743681897~hmac=b2337bc9ce448c393e17851f0d58311c4e8d73f4188e1063617136fcad5986e8&w=1380",
      name: "mohammed aslam",
      designation: "frontend developer",
    },
    {
      img: "https://img.freepik.com/free-psd/3d-illustration-human-avatar-profile_23-2150671122.jpg?t=st=1743678338~exp=1743681938~hmac=35f79b6435be11f6f6c4a07fe3827961e9eca541cc968afc282e63d3f57a6993&w=1380",
      name: "Akash Pradeep",
      designation: "QA Analyst",
    },
    {
      img: "https://img.freepik.com/free-psd/3d-render-avatar-character_23-2150611765.jpg?t=st=1743678383~exp=1743681983~hmac=3a41ea3f54ba83a752c9f0012b1b49de5ee471cba9df21b28cac97656bdf7ba8&w=1380",
      name: "Rahuk",
      designation: "QA Analyst",
    },
    {
      img: "https://img.freepik.com/free-psd/3d-illustration-human-avatar-profile_23-2150671128.jpg?t=st=1743678928~exp=1743682528~hmac=04bf1c6ad29813c2452fda1667d0ee4d52b91ac7e137ce824781f9954e9e345e&w=1380",
      name: "Anchitha",
      designation: "Backend Developer",
    },
    {
      img: "https://img.freepik.com/free-psd/3d-illustration-human-avatar-profile_23-2150671132.jpg?t=st=1743678962~exp=1743682562~hmac=eaf2cc84eb0f1a0cae34f16814dc30f0462a07956228615962d8c668ea1abf8a&w=1380",
      name: "Thamara",
      designation: "UI/UX Designer",
    },
    {
      img: "https://img.freepik.com/free-psd/3d-illustration-human-avatar-profile_23-2150671124.jpg?t=st=1743678988~exp=1743682588~hmac=6612aed266743eb293a8f17c1abb8295e6ee25f5c164c3904830119840ba1c41&w=1380",
      name: "Faisal",
      designation: "frontend developer",
    },
  ];

  const handleClose = () => {
    setShowModal(false);
    setData({
      id: "",
      project_name: "",
      web_url: "",
      api_url: "",
      admin_url: "",
      members: [],
    });
  };

  const getSearchDataHandler = (filter) => {
    let raw = {
      start_date: filter?.start_date,
      end_date: filter?.end_date,
      user: filter?.user,
      page: filter?.page,
      keyword: filter?.keyword,
    };
    dispatch(getProjects(raw));
  };

  const clearSearchHandler = () => {
    let value = {
      start_date: "",
      end_date: "",
      user: "",
      page: 0,
      keyword: "",
    };
    setSearchData({
      ...value,
    });
    getSearchDataHandler(value);
  };

  const onChangeHandler = (key, value) => {
    setData({
      ...data,
      [key]: value,
    });
    setErr({
      ...err,
      [key]: "",
    });
  };

  const onSearchChangeHandler = (key, value) => {
    setSearchData({
      ...searchData,
      [key]: value,
    });
  };

  const validate = () => {
    let temp = {};
    if (!data?.project_name?.trim()?.length) {
      temp = {
        ...temp,
        project_name: "Please enter project name",
      };
    }
    if (!data?.web_url?.trim()?.length) {
      temp = {
        ...temp,
        web_url: "Please enter web url",
      };
    }
    if (!data?.api_url?.trim()?.length) {
      temp = {
        ...temp,
        api_url: "Please enter api url",
      };
    }
    if (!data?.admin_url?.trim()?.length) {
      temp = {
        ...temp,
        admin_url: "Please enter admin url",
      };
    }
    if (!data?.members?.length) {
      temp = {
        ...temp,
        members: "Please select members",
      };
    }
    if (Object.values(temp).length != 0) {
      setErr(temp);
      return false;
    } else {
      setErr({});
      return true;
    }
  };

  const submitHandler = () => {
    if (validate()) {
      let raw = {
        project_name: data?.project_name,
        web_url: data?.web_url,
        api_url: data?.api_url,
        admin_url: data?.admin_url,
        members: data?.members?.map((ele) => ele?._id),
      };
      if (data?.id) {
        raw = {
          ...raw,
          id: data?.id,
        };
        dispatch(
          addProjects(raw, (res) => {
            if (res) {
              handleClose();
              getSearchDataHandler(searchData);
            }
          })
        );
      } else {
        dispatch(
          addProjects(raw, (res) => {
            if (res) {
              handleClose();
              getSearchDataHandler(searchData);
            }
          })
        );
      }
    }
  };

  const onViewHandler = (ele) => {
    window.open(`${ele?.web_url}?urltoken=${localStorage.getItem("token")}`, "_blank");
    // let res = axios.get(
    //   `${ele?.web_url}?urltoken=${localStorage.getItem("token")}`
    // );
    // console.log(res, "resghugh");
    // setTimeout(() => {
     
    // }, 2000);
  };

  const onEditHandler = (ele) => {
    setData({
      id: ele?._id,
      project_name: ele?.project_name,
      web_url: ele?.web_url,
      api_url: ele?.api_url,
      admin_url: ele?.admin_url,
      members: allEmployees
        ?.filter((e) => ele?.members?.includes(e?._id))
        ?.map((el) => {
          return {
            label: el.name,
            value: el._id,
            _id: el._id,
          };
        }),
    });
    setShowModal(true);
  };

  return (
    console.log(data),
    (
      <>
        <div className="main__section">
          <div className="d-flex justify-content-end gap-2">
            {" "}
            {localStorage.getItem("role") == "super_admin" ? (
              <>
                {" "}
                <Button
                  onClick={() => navigate("/employees")}
                  className="addBtn"
                >
                  Add Employees
                </Button>
                <Button onClick={() => setShowModal(true)} className="addBtn">
                  Add Project
                </Button>
              </>
            ) : (
              <></>
            )}
          </div>

          {!logs ? (
            <Tabs
              defaultActiveKey="projects"
              id="uncontrolled-tab-example"
              className="mb-3"
            >
              <Tab eventKey="projects" title="Projects">
                <div className="projects">
                  {localStorage.getItem("role") == "super_admin" ? (
                    <div className="row row-cols-12 mb-4">
                      <div className="table__header between">
                        <DatePicker
                          className="form-control date__picker"
                          placeholderText="Start Date"
                          selected={searchData?.start_date}
                          endDate={new Date()}
                          onChange={(date) => {
                            onSearchChangeHandler("start_date", date);
                          }}
                          dateFormat={"dd MMM YYYY"}
                        />

                        <DatePicker
                          className="form-control date__picker"
                          placeholderText="End Date"
                          selected={searchData?.end_date}
                          minDate={searchData?.start_date}
                          endDate={new Date()}
                          onChange={(date) => {
                            onSearchChangeHandler("end_date", date);
                          }}
                          dateFormat={"dd MMM YYYY"}
                        />
                        <input
                          type="text"
                          placeholder="Keyword Search"
                          className="form-control"
                          onChange={(e) =>
                            onSearchChangeHandler("keyword", e.target?.value)
                          }
                          value={searchData?.keyword}
                        />
                        <div className="col-2">
                          <div className="d-flex gap-2">
                            <button
                              className="btn btn-primary"
                              onClick={() => getSearchDataHandler(searchData)}
                            >
                              <img src="/search.svg" alt="" />
                            </button>
                            <button
                              className="btn btn-primary"
                              onClick={() => clearSearchHandler()}
                            >
                              <img src="/close.svg" alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  {projectData?.map((ele, i) => {
                    return (
                      <>
                        <Accordion>
                          <Accordion.Item eventKey={i}>
                            <Accordion.Header>
                              <div className="accordian__header">
                                <img src="/folder.svg" alt="" />
                                {/* <a href="#" target="_blank"> */}
                                <span style={{ color: "white" }}>
                                  {ele?.project_name}
                                </span>
                                {/* </a> */}
                              </div>
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="project__details">
                                <div className="d-flex gap-2 mb-5 justify-content-end">
                                  {localStorage.getItem("role") ==
                                  "super_admin" ? (
                                    <div
                                      className="view_webiste"
                                      onClick={() => onEditHandler(ele)}
                                    >
                                      Edit
                                    </div>
                                  ) : (
                                    <></>
                                  )}

                                  <div
                                    className="view_webiste"
                                    onClick={() => onViewHandler(ele)}
                                  >
                                    View Website
                                  </div>
                                </div>
                                <div className="titles">
                                  <ul>
                                    <li>Teams</li>
                                    {localStorage.getItem("role") ==
                                    "super_admin" ? (
                                      <li onClick={() => setLogs(true)}>
                                        Logs
                                      </li>
                                    ) : (
                                      <></>
                                    )}
                                  </ul>
                                </div>
                                <div className="teams">
                                  {ele?.memberDetails?.map((e, i) => {
                                    return (
                                      <div className="grid" key={i}>
                                        <img src="/profile.png" alt="" />
                                        <h4>
                                          {e?.firstname + " " + e?.lastname}
                                        </h4>
                                        <p>{e?.email}</p>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </>
                    );
                  })}
                </div>
              </Tab>
            </Tabs>
          ) : (
            <ProjectLogs setLogs={setLogs} />
          )}
        </div>
        <Modal
          className="main__modal"
          centered
          size="lg"
          show={showModal}
          onHide={handleClose}
        >
          <h2>Add Project</h2>
          <Modal.Body>
            <div className="row">
              <div className="col-md-6">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Project Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter project name"
                    onChange={(e) =>
                      onChangeHandler("project_name", e.target?.value)
                    }
                    value={data?.project_name}
                  />
                  <span className="text-danger">{err?.project_name}</span>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Web Url</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter web url"
                    onChange={(e) =>
                      onChangeHandler("web_url", e.target?.value)
                    }
                    value={data?.web_url}
                  />
                  <span className="text-danger">{err.web_url}</span>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Api Url</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter api url"
                    onChange={(e) =>
                      onChangeHandler("api_url", e.target?.value)
                    }
                    value={data?.api_url}
                  />
                  <span className="text-danger">{err.api_url}</span>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Admin Url</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter admin url"
                    onChange={(e) =>
                      onChangeHandler("admin_url", e.target?.value)
                    }
                    value={data?.admin_url}
                  />
                  <span className="text-danger">{err.admin_url}</span>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Members</Form.Label>
                  {/* <Select
                  placeholder="Select members"
                  name="members"
                  options={[]}
                  value={data?.members}
                  getOptionLabel={(o) => o?.dial_code}
                  getOptionValue={(o) => o?._id}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={(e) => {
                    onChangeHandler("members", e);
                  }}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                /> */}
                  <MultiSelect
                    placeholderText={"text"}
                    options={
                      allEmployees?.length
                        ? [
                            ...allEmployees?.map((ele) => ({
                              label: ele.name,
                              value: ele._id,
                              _id: ele._id,
                            })),
                          ]
                        : []
                    }
                    value={data?.members}
                    onChange={(e) => {
                      onChangeHandler("members", e);
                    }}
                    className="basic-multi-select"
                    labelledBy={"Select"}
                  />

                  <span className="text-danger">{err.members}</span>
                </Form.Group>
              </div>
              <div className="col-md-12">
                <div className="modal__footer">
                  <Button variant="primary" onClick={submitHandler}>
                    Submit
                  </Button>
                  <Button variant="primary" onClick={handleClose}>
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    )
  );
};
export default Projects;
